import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  newComment: '',
  isAnonymous: false,
  isAnonymousQuestion: false,
  selectedFile: null,
  fileType: null,
  isRecording: false,
  isPaused: false,
  recordingDuration: 0,
  audioBlob: null,
  selectedVoicePreset: 'Normal',
  voicePitch: 1.0,
  showVoiceSelection: false,
  isPlayingPreview: false,
  previewCurrentTime: 0,
  previewDuration: 0,
  uploading: false,
};

const commentBoxSlice = createSlice({
  name: 'commentBox',
  initialState,
  reducers: {
    setNewComment: (state, action) => {
      state.newComment = action.payload;
    },
    setIsAnonymous: (state, action) => {
      state.isAnonymous = action.payload;
    },
    setIsAnonymousQuestion: (state, action) => {
      state.isAnonymousQuestion = action.payload;
    },
    setSelectedFile: (state, action) => {
      state.selectedFile = action.payload;
    },
    setFileType: (state, action) => {
      state.fileType = action.payload;
    },
    setIsRecording: (state, action) => {
      state.isRecording = action.payload;
    },
    setIsPaused: (state, action) => {
      state.isPaused = action.payload;
    },
    setRecordingDuration: (state, action) => {
      state.recordingDuration = action.payload;
    },
    setAudioBlob: (state, action) => {
      state.audioBlob = action.payload;
    },
    setSelectedVoicePreset: (state, action) => {
      state.selectedVoicePreset = action.payload;
    },
    setVoicePitch: (state, action) => {
      state.voicePitch = action.payload;
    },
    setShowVoiceSelection: (state, action) => {
      state.showVoiceSelection = action.payload;
    },
    setIsPlayingPreview: (state, action) => {
      state.isPlayingPreview = action.payload;
    },
    setPreviewCurrentTime: (state, action) => {
      state.previewCurrentTime = action.payload;
    },
    setPreviewDuration: (state, action) => {
      state.previewDuration = action.payload;
    },
    setUploading: (state, action) => {
      state.uploading = action.payload;
    },
    resetCommentBox: state => {
      return { ...initialState };
    },
    resetRecording: state => {
      state.isRecording = false;
      state.isPaused = false;
      state.recordingDuration = 0;
      state.audioBlob = null;
      state.isPlayingPreview = false;
      state.previewCurrentTime = 0;
      state.previewDuration = 0;
      state.showVoiceSelection = false;
    },
  },
});

export const {
  setNewComment,
  setIsAnonymous,
  setIsAnonymousQuestion,
  setSelectedFile,
  setFileType,
  setIsRecording,
  setIsPaused,
  setRecordingDuration,
  setAudioBlob,
  setSelectedVoicePreset,
  setVoicePitch,
  setShowVoiceSelection,
  setIsPlayingPreview,
  setPreviewCurrentTime,
  setPreviewDuration,
  setUploading,
  resetCommentBox,
  resetRecording,
} = commentBoxSlice.actions;

export default commentBoxSlice.reducer;
